<template>
    <div>
        <h1 class="font-size-big">Page Not Found</h1>
        <p class="font-size-middle">{{ message }}</p>
    </div>
</template>

<script>
    export default {
        name: 'PageNotFound',
        props: {
            message: {
                type: String,
                default: '',
            },
        },
    };
</script>

<style scoped>
    div {
        text-align: center;
    }
    h1 {
        color: white;
    }
    p {
        color: white;
    }
</style>
